import type { ReactNode } from 'react';
import { Animated, type ViewStyle } from 'react-native';
import { useEntranceAnimation } from './useAnimations';

interface AnimatedSectionProps {
  children: ReactNode;
  delay?: number;
  duration?: number;
  style?: ViewStyle;
}

export function AnimatedSection({
  children,
  delay = 0,
  duration = 800,
  style,
}: Readonly<AnimatedSectionProps>) {
  const { style: animatedStyle } = useEntranceAnimation({
    delay,
    duration,
    translateY: 40,
  });

  return <Animated.View style={[animatedStyle, style]}>{children}</Animated.View>;
}
